// extracted by mini-css-extract-plugin
module.exports = {"actual":"_7a3fb80146--actual--KF2Fy","label":"_7a3fb80146--label--DSBoP"};